import React from "react"
import { EditBandFormField, isLikelyUrl } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface InstagramProps {
  band: Band
}

export const Instagram: React.FC<InstagramProps> = ({ band }) => {
  const fieldData = {
    field: "instagram_url",
    name: "instagramUrl",
    label: "Your instagram url",
    placeholder: "https://instagram.com/yourIGname",
    required: false,
  }

  return (
    <EditBandFormField type="text" fieldData={fieldData} validate={isLikelyUrl} />
  )
}
